const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

export default {
    /**
     * @param {String | Date} date
     */
    short(date) {
        const finalDate = new Date(date);
        const mm = finalDate.getMonth() + 1;
        const dd = finalDate.getDate();

        return [
            finalDate.getFullYear(),
            (mm > 9 ? "" : "0") + mm,
            (dd > 9 ? "" : "0") + dd
        ].join('-');
    },

    /**
     * @param {String | Date} date
     */
    MMDDYYYY(date) {
        const d = new Date(date)
        return `${monthNames[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`
    },

    /**
     * @param {String | Date} date
     */
    MMDDYYYYHHmmss(date) {
        const padZeros = (num, length) => String(num).padStart(length, '0')
        const d = new Date(date)
        const hours = padZeros(d.getHours(), 2)
        const minutes = padZeros(d.getMinutes(), 2)
        const seconds = padZeros(d.getSeconds(), 2)
        return `${monthNames[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()} ${hours}:${minutes}:${seconds}`
    }
}
